/* eslint-disable */
import ACTIONS from "../Design_Asset_Actions.json";
import embLabels from "../../../config/emb-labels-en.json";

const useAssetEditStatus = (deps) => {
  const {
    projectTypeValue, dispatch, UserScope, projectType,
    loading, setLoading,
    displayPage, setDisplayPage,
    sldLoadCompleted, setSldLoadCompleted,
    useCaseValidGenset, setUseCaseValidGenset,
    deleteOneDER, setDeleteOneDER,
    defaultConfigurationStatus, setDefaultConfigurationStatus,
    siteCreated, setSiteCreated,
    isOpen, setIsOpen,
    siteType, setSiteType,
    evceDiagramChangeRequired, setEvceDiagramChangeRequired,
    isAllowMultipleLoads, setIsAllowMultipleLoads,
    isExportOptimization, setIsExportOptimization,
    switchboardType, setSwitchboardType,
    clientType, setClientType,
    architectureType, setArchitectureType,
    nominalVoltage, setNominalVoltage,
    isSelectSpanishCode, setIsSelectSpanishCode,
    defaultPreFillData, setDefaultPreFillData,
    availableDer, setAvailableDer,
    useCases, setUseCases,
    isEvce, setIsEvce,
    prevPvGroupNames, setPrevPvGroupNames,
    batteryCommunicationData, setBatteryCommunicationData,
    evCommunicationData, setEvCommunicationData,
    powerMeter, setPowerMeter,
    communicationState, setCommunicationState,
    cbCommunicationValues, setCbCommunicationValues,
    detailsBlock, setDetailsBlock,
    selectedValues, setSelectedValues,
    configData, setConfigData,
    isLoadNameUnique, setIsLoadNameUnique,
    gsxExternalId, setGsxExternalId,
    isBessController, setIsBessController,
    assetDetailsDisplay, setAssetDetailsDisplay,
    assetInfo, setAssetInfo,
    bessControllerPrevValue, setBessControllerPrevValue,
    cbDer, setCbder,
    CBValues, setCBValues,
    defaultsMinMax, setDefaultsMinMax,
    coordinates, setCoordinates,
    rectangleWidth, setRectangleWidth,
    snackBar, setSnackBar,
    alert, setAlert,
    confirm, setConfirm,
    remoteConfirm, setRemoteConfirm,
    duplicateUpdate, setDuplicateUpdate,
    runCalculateCoordinates, setRunCalculateCoordinates,
    runGenerateComponentsBlock, setRunGenerateComponentsBlock,
    batteryRack, setBatteryRack,
    batterySystemA2EConfig, setBatterySystemA2EConfig,
    isOpenLoadConfig, setIsOpenLoadConfig,
    isOpenGtConfig, setIsOpenGtConfig,
    loadSide, setLoadSide,
    isAntiIslandingRelayEnable, setIsAntiIslandingRelayEnable,
    gridTransitionOnline, setGridTransitionOnline,
    defaultCbData, setDefaultCbData,
    defaultPmData, setDefaultPmData,
    defaultDummyCbData, setDefaultDummyCbData,
    gensetAssetData, setGensetAssetData,
    evContactorData, setEVContactorData,
    gTContractorData, setGTContractorData,
    defaultGTData, setGTDefaultData,
    evDefaultData, setEVDefaultData,
    evPMData, setEVPMData,
    jsonData, setJsonData,
    isContactorEnabled, setIsContactorEnabled,
    cbLoadData, setCBLoadData,
    currentProject, setCurrentProject,
    defaultComponentData, setDefaultComponentData,
    updateComponents, setUpdateComponents,
    cbCount, setCbCount,
    spanishCodeRealTime, setSpanishCodeRealTime,
    assetDefaultValues, setAssetDefaultValues,
    isAssetConfigChanged, setIsAssetConfigChanged,
    gtTempConfigData, setGtTempConfigData,
    projectStatusData,
    deploymentReady, setDeploymentReady,
    ComponentData, ComponentDataDispatch,
    CBAssetList, CBAssetListDispatch,
    CBEVList, CBEVListDispatch,
    CBLoadList, CBLoadListDispatch,
    CBGTList, CBGTListDispatch,
    firstTimeCall, setFirstTimecall,
    multipleLoads, setMultipleLoads,
    count, countDispatch,
    projectKind, projectKindDispatch,
    PVDetails, PVDetailsDispatch,
    selectedLoadIndx, setSelectedLoadIndx,
    projectId,
    initialRenderCoordinates,
    initialRenderPvConfigured,
    snackBarRef,
    isUpdatingComponent,
    remoteMain, setRemoteMain,
    considerSelected, setConsiderSelected,
    assetDetails, setAssetDetails,
    // projectKind flags
    isMgaasAnsi, isDaasAnsi, isDaasEto, isMgaasIec, isDaasIec,
    isMgaasAnsiGrid, isDaasAnsiGrid, isDaasEtoGrid,
    isMgaasAnsiIsland, isDaasAnsiIsland, isDaasEtoIsland,
    isMgaasIecGrid, isDaasIecGrid, isMgaasIecIsland,
    isGridConnected, isGridConnectedGSX, isIslandable, isIslandableGSX,
    isA2E, isLineSide, isExistingSwitchBoard, isLoadSide, isNewSwitchBoard,
    isGreenStruxure, isGeneric, isGreenStruxureMicrogrid,
    isPVGensetATS, isFuelSaver, isPVBessNR, isPVHybrid, isPVGensetA2E,
    isGensetMainNoBess, isNoFuel, isETO,
    isMGaaSETOGrid, isMGaaSETOIsland, isMGaaSETO, isMGaaSETOGensetPvHybrid,
    isNMGaaSETOGrid, isNMGaaSETOIsland, isNMGaaSETO, isNMGaaSETOGensetPvHybrid,
    isMgaasAnsiOffGrid, isMgaasIecOffGrid, isMassEtoOffGrid,
    // cross-hook ref
    fnRef,
  } = deps;

  // Cross-hook function aliases
  const callSnackbar = (...args) => fnRef.current.callSnackbar(...args);
  const generateComponentsBlock = (...args) => fnRef.current.generateComponentsBlock(...args);
  const saveDraftComponentData = (...args) => fnRef.current.saveDraftComponentData(...args);

  const closePvDetailsBlock = () => {
    PVDetailsDispatch({
      type: ACTIONS.CLOSE_PVDISPLAY_CONTENT,
      payload: {
        selectSubPv: PVDetails?.selectSubPv,
        selectedPv: PVDetails?.selectedPv,
      }
    });
  };

  const isCopyAllButtonDisabled = (selectedPv) => {
    switch (selectedPv) {
      case 3:
        const configured1pv = PVDetails?.pvset1Data?.filter((pv1) => pv1.status);
        const configured1pvSameAsset = configured1pv.every(
          (pv1) =>
            pv1?.assetDetails[0]?.assetId ===
            configured1pv[0]?.assetDetails[0]?.assetId
        );
        if (PVDetails?.pvset1Data?.every((pv1) => pv1.status)) return false;
        else return configured1pvSameAsset && configured1pv.length;
      case 4:
        const configured2pv = PVDetails?.pvset2Data?.filter((pv2) => pv2.status);
        const configured2pvSameAsset = configured2pv.every(
          (pv2) =>
            pv2?.assetDetails[0]?.assetId ===
            configured2pv[0]?.assetDetails[0]?.assetId
        );
        if (PVDetails?.pvset2Data?.every((pv2) => pv2.status)) return false;
        else return configured2pvSameAsset && configured2pv.length;
      case 5:
        const configured3pv = PVDetails?.pvset3Data?.filter((pv3) => pv3.status);
        const configured3pvSameAsset = configured3pv.every(
          (pv3) =>
            pv3?.assetDetails[0]?.assetId ===
            configured3pv[0]?.assetDetails[0]?.assetId
        );
        if (PVDetails?.pvset3Data?.every((pv3) => pv3.status)) return false;
        else return configured3pvSameAsset && configured3pv.length;
      default:
        break;
    }
  };

  const copyAllPvs = () => {
    PVDetailsDispatch({
      type: ACTIONS.COPY_ALL_PV,
    });
    PVDetailsDispatch({
      type: ACTIONS.PV_CONFIGURED_STATUS,
    });

    // this.updatePvHistory(index, selectedPV);
    const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
    setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
    sessionStorage.setItem("componentDataModified",true);
    callSnackbar("information", "PV Configured Successfully");
  };

  //* LOCAL STORAGE

  const assetEditStatusUpdateDER = (e, type, status) => {
    let derHistory = JSON.parse(sessionStorage.getItem("derHistory"));
    switch (type) {
    
      case embLabels.UTILITY:
        derHistory.Utility[e.target.name] = e.target.value;
        checkUpdatedStatus(0, status);
        break;
     
      case embLabels.GENSET:
        derHistory.Genset[e.target.name] = e.target.value;
        checkUpdatedStatus(1, status);
        break;
      case embLabels.BESS:
        derHistory.BESS[e.target.name] = e.target.value;
        checkUpdatedStatus(2, status);
        break;

      case embLabels.EV:
        derHistory.EV[e.target.name] = e.target.value;
        checkUpdatedStatus(5, status);
        break;

      case embLabels.CHP:
        derHistory.CHP[e.target.name] = e.target.value;
        checkUpdatedStatus(7, status);
        break;

      case embLabels.HYBRID:
        derHistory.Hybrid[e.target.name] = e.target.value;
        checkUpdatedStatus(9, status);
        break;
        case embLabels.GT:
        derHistory.GT[e.target.name] = e.target.value;
        checkUpdatedStatus(10, status);
        break;

      default:
        break;
    }
    sessionStorage.setItem("derHistory", JSON.stringify(derHistory));
  };

  const assetEditStatusUpdateLoad = (e, status, selectedLoad) => {
    let loadHistory = [];
    if (sessionStorage.getItem("loadHistory") !== "") {
      loadHistory = JSON.parse(sessionStorage.getItem("loadHistory"));
    }

    if (loadHistory[selectedLoad] === undefined) {
      loadHistory[selectedLoad] = {};
    }
    if (loadHistory[selectedLoad] === null) {
      loadHistory[selectedLoad] = {};
    }
    let loadHistoryRef = loadHistory[selectedLoad];
    loadHistoryRef[e.target.name] = e.target.value;
    loadHistory[selectedLoad] = loadHistoryRef;
    sessionStorage.setItem("loadHistory", JSON.stringify(loadHistory));
    checkUpdatedStatus(4, status);
  };

  const assetEditStatusUpdateAssetCB = (e, status, selectedAssetCb) => {
    const dataConfig = { ...configData?.cbConfigData };
    const {name, value, checked, type} = e?.target;
    let cbAssetHistory = [];
    if (sessionStorage.getItem("cbAssetHistory") !== "") {
      cbAssetHistory = JSON.parse(sessionStorage.getItem("cbAssetHistory"));
    }

    if (cbAssetHistory[selectedAssetCb] === undefined) {
      cbAssetHistory[selectedAssetCb] = {};
    }
    if (cbAssetHistory[selectedAssetCb] === null) {
      cbAssetHistory[selectedAssetCb] = {};
    }

    let cbAssetHistoryRef = cbAssetHistory[selectedAssetCb];
    if(cbAssetHistoryRef) return;
    if (name === "motorized") {
      if (
        [embLabels.GRID_CONNECTED,embLabels.ISLANDABLE, embLabels.OFF_GRID].includes(siteType) &&
        clientType === embLabels.GENERIC_PROJECT &&
       ( projectTypeValue === "MGaaS IEC" || projectTypeValue === "MGaaS ETO"|| projectTypeValue === "NMGaaS ETO")
      ) {
        if(checked){
          if(cbAssetHistoryRef?.contactor){
            cbAssetHistoryRef[name] = checked;
            cbAssetHistoryRef.contactor = !checked;
            dataConfig[name] = checked;
            dataConfig.contactor = !checked;
          }else{
            cbAssetHistoryRef[name] = checked;
            dataConfig[name] = checked;
          }
        }else{
          cbAssetHistoryRef[name] = checked;
          dataConfig[name] = checked;
        }
      } else {
        cbAssetHistoryRef[name] = true;
      }
    } else if(name === "contactor"){
      if (
        siteType === embLabels.GRID_CONNECTED &&
        clientType === embLabels.GENERIC_PROJECT &&
       ( projectTypeValue === "MGaaS IEC" || projectTypeValue === "MGaaS ETO"|| projectTypeValue === "NMGaaS ETO")
      ) {
        if(e?.target?.checked){
          if(cbAssetHistoryRef?.motorized){
            cbAssetHistoryRef[name] = checked;
            cbAssetHistoryRef.motorized = !checked;
            dataConfig[name] = checked;
            dataConfig.motorized = !checked;
          }else{
            cbAssetHistoryRef[name] = checked;
            dataConfig[name] = checked;
          }
        }else{
          cbAssetHistoryRef[name] = checked;
          dataConfig[name] = checked;
        }
    } else {
        cbAssetHistoryRef[name] = true;
      }
    }else {
      if((projectKind?.isDaasAnsi || projectKind?.isDaasEto) && name === "name" ){
        cbAssetHistoryRef[name] = value.toLowerCase();
      dataConfig[name] = value?.toLowerCase();
      }else{
        cbAssetHistoryRef[name] = value;
      dataConfig[name] = value;
      }
      
    }
    cbAssetHistory[selectedAssetCb] = cbAssetHistoryRef;
    setConfigData((prevState) => ({ ...prevState, cbConfigData: dataConfig }));
    sessionStorage.setItem("cbAssetHistory", JSON.stringify(cbAssetHistory));
    checkUpdatedStatus(6, status);
  };

  const assetEditStatusUpdateLoadCb = (e, status, selectedLoadCb) => {
    let cbLoadHistory = [];
    if (sessionStorage.getItem("cbLoadHistory") !== "") {
      cbLoadHistory = JSON.parse(sessionStorage.getItem("cbLoadHistory"));
    }

    if (cbLoadHistory[selectedLoadCb] === undefined) {
      cbLoadHistory[selectedLoadCb] = {};
    }

    if (cbLoadHistory[selectedLoadCb] === null) {
      cbLoadHistory[selectedLoadCb] = {};
    }

    let cbLoadHistoryRef = cbLoadHistory[selectedLoadCb];
    if (e.target.name === "motorized") {
      cbLoadHistoryRef[e.target.name] = e.target.checked;
    }else if(e.target.name === "contactor") {
      cbLoadHistoryRef[e.target.name] = e.target.checked;
    } else {
      cbLoadHistoryRef[e.target.name] = e.target.value;
    }
    cbLoadHistory[selectedLoadCb] = cbLoadHistoryRef;
    sessionStorage.setItem("cbLoadHistory", JSON.stringify(cbLoadHistory));
    checkUpdatedStatus(6, status);
  };
   const assetEditStatusUpdateGtCb = (e, status, selectedGtCb) => {
    let cbGtHistory = [];
    if (sessionStorage.getItem("cbGtHistory") !== "") {
      cbGtHistory = JSON.parse(sessionStorage.getItem("cbGtHistory"));
    }

    if (cbGtHistory[selectedGtCb] === undefined) {
      cbGtHistory[selectedGtCb] = {};
    }

    if (cbGtHistory[selectedGtCb] === null) {
      cbGtHistory[selectedGtCb] = {};
    }

    let cbLoadHistoryRef = cbGtHistory[selectedGtCb];
    if (e.target.name === "motorized") {
      cbLoadHistoryRef[e.target.name] = e.target.checked;
    }else if(e.target.name === "contactor") {
      cbLoadHistoryRef[e.target.name] = e.target.checked;
    } else {
      cbLoadHistoryRef[e.target.name] = e.target.value;
    }
    cbGtHistory[selectedGtCb] = cbLoadHistoryRef;
    sessionStorage.setItem("cbGtHistory", JSON.stringify(cbGtHistory));
    checkUpdatedStatus(10, status);
  };

  const assetEditStatusUpdateEvCb = (e, status, selectedEvCb) => {
    let cbEvHistory = [];
    if (sessionStorage.getItem("cbEvHistory") !== "") {
      cbEvHistory = JSON.parse(sessionStorage.getItem("cbEvHistory"));
    }

    if (cbEvHistory[selectedEvCb] === undefined) {
      cbEvHistory[selectedEvCb] = {};
    }

    if (cbEvHistory[selectedEvCb] === null) {
      cbEvHistory[selectedEvCb] = {};
    }

    let cbEvHistoryRef = cbEvHistory[selectedEvCb];
    if (e.target.name === "motorized") {
      cbEvHistoryRef[e.target.name] = e.target.checked;
    } else {
      cbEvHistoryRef[e.target.name] = e.target.value;
    }

    cbEvHistory[selectedEvCb] = cbEvHistoryRef;
    sessionStorage.setItem("cbEvHistory", JSON.stringify(cbEvHistory));
    checkUpdatedStatus(6, status);
  };

  const assetEditStatusUpdatePv = (e, status, selectedPv, selectedSubPvRaw) => {
    let selectedSubPv = selectedSubPvRaw - 1;
    const onlyNumber = /^(\d+(\.\d+)?|)$/;
    let pvHistory = JSON.parse(sessionStorage.getItem("pvHistory"));
    if (selectedPv === 3) {
      if (pvHistory.pv1[selectedSubPv] === undefined) {
        pvHistory.pv1[selectedSubPv] = {};
      }
      if (pvHistory.pv1[selectedSubPv] === null) {
        pvHistory.pv1[selectedSubPv] = {};
      }
      let pvHistoryRef = pvHistory.pv1[selectedSubPv];

      switch (e.target.name) {
        case "groupName":
          pvHistoryRef[e.target.name] = e.target.value;
          break;
        case "group_max_power":
          if (onlyNumber.test(e.target.value) && e.target.value <= 99999) {
            pvHistoryRef[e.target.name] = e.target.value;
          }
          break;
        case "max_power":
          if (!isNaN(e.target.value)) {
            pvHistoryRef[e.target.name] = e.target.value;
          }
          break;
        default:
          pvHistoryRef[e.target.name] = e.target.value;
          break;
      }

      pvHistory.pv1[selectedSubPv] = pvHistoryRef;
    } else if (selectedPv === 4) {
      if (pvHistory.pv2[selectedSubPv] === undefined) {
        pvHistory.pv2[selectedSubPv] = {};
      }
      if (pvHistory.pv2[selectedSubPv] === null) {
        pvHistory.pv2[selectedSubPv] = {};
      }
      let pvHistoryRef = pvHistory.pv2[selectedSubPv];
      switch (e.target.name) {
        case "groupName":
          pvHistoryRef[e.target.name] = e.target.value;
          break;
        case "group_max_power":
          if (onlyNumber.test(e.target.value) && e.target.value <= 99999) {
            pvHistoryRef[e.target.name] = e.target.value;
          }
          break;
        case "max_power":
          if (!isNaN(e.target.value)) {
            pvHistoryRef[e.target.name] = e.target.value;
          }
          break;
        default:
          pvHistoryRef[e.target.name] = e.target.value;
          break;
      }
      pvHistory.pv2[selectedSubPv] = pvHistoryRef;
    } else if (selectedPv === 5) {
      if (pvHistory.pv3[selectedSubPv] === undefined) {
        pvHistory.pv3[selectedSubPv] = {};
      }
      if (pvHistory.pv3[selectedSubPv] === null) {
        pvHistory.pv3[selectedSubPv] = {};
      }
      let pvHistoryRef = pvHistory.pv3[selectedSubPv];
      switch (e.target.name) {
        case "groupName":
          pvHistoryRef[e.target.name] = e.target.value;
          break;
        case "group_max_power":
          if (onlyNumber.test(e.target.value) && e.target.value <= 99999) {
            pvHistoryRef[e.target.name] = e.target.value;
          }
          break;
        case "max_power":
          if (!isNaN(e.target.value)) {
            pvHistoryRef[e.target.name] = e.target.value;
          }
          break;
        default:
          pvHistoryRef[e.target.name] = e.target.value;
          break;
      }
      pvHistory.pv3[selectedSubPv] = pvHistoryRef;
    }
    sessionStorage.setItem("pvHistory", JSON.stringify(pvHistory));
    checkUpdatedStatus(3, status);
    setIsAssetConfigChanged(pvHistory);
  };

  const assetEditStatusUpdateAssetPM = (e, status, selectedAssetPm) => {
    let pmAssetHistory = [];
    if (sessionStorage.getItem("pmAssetHistory") !== "") {
      pmAssetHistory = JSON.parse(sessionStorage.getItem("pmAssetHistory"));
    }

    if (pmAssetHistory[selectedAssetPm] === undefined) {
      pmAssetHistory[selectedAssetPm] = {};
    }
    if (pmAssetHistory[selectedAssetPm] === null) {
      pmAssetHistory[selectedAssetPm] = {};
    }

    let pmAssetHistoryRef = pmAssetHistory[selectedAssetPm];
    pmAssetHistoryRef[e.target.name] = e.target.value;
    pmAssetHistory[selectedAssetPm] = pmAssetHistoryRef;
    sessionStorage.setItem("pmAssetHistory", JSON.stringify(pmAssetHistory));
    checkUpdatedStatus(8, status, selectedAssetPm);
  };

  const assetEditStatusUpdateEvPM = (e, status, selectedAssetPm) => {
    let pmEvHistory = [];
    if (sessionStorage.getItem("pmEvHistory") !== "") {
      pmEvHistory = JSON.parse(sessionStorage.getItem("pmEvHistory"));
    }

    if (pmEvHistory[selectedAssetPm] === undefined) {
      pmEvHistory[selectedAssetPm] = {};
    }
    if (pmEvHistory[selectedAssetPm] === null) {
      pmEvHistory[selectedAssetPm] = {};
    }

    let pmAssetHistoryRef = pmEvHistory[selectedAssetPm];
    pmAssetHistoryRef[e.target.name] = e.target.value;
    pmEvHistory[selectedAssetPm] = pmAssetHistoryRef;
    sessionStorage.setItem("pmEvHistory", JSON.stringify(pmEvHistory));
    checkUpdatedStatus(8, status);
  };

  const checkUpdatedStatus = (type, status, selectedAsset) => {
    let derStatus = [];
    if (sessionStorage.getItem("derStatus") !== "") {
      derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    }

    derStatus[type] = status;

    sessionStorage.setItem("derStatus", JSON.stringify(derStatus));
    detailsModifiedStataus();
  };

  const detailsModifiedStataus = (selectedAsset) => {
    const assests = ["Utility","Genset","BESS","PV","Load","EV"];
    let derStatus = [];
    if (sessionStorage.getItem("derStatus") !== "") {
      derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    }
    sessionStorage.setItem("assetEditStatus", "");
    let assetEditStatus = [];
    for (let i = 0; i < derStatus.length; i++) {
      if (derStatus[i] === true) {
        switch (i) {
          case 0:
            assetEditStatus.push("Utility");
            assetEditStatus.push(true);
            break;
          case 1:
            assetEditStatus.push("Genset");
            assetEditStatus.push(true);
            break;
          case 2:
            assetEditStatus.push("BESS");
            assetEditStatus.push(true);
            break;
          case 3:
            assetEditStatus.push("PV");
            assetEditStatus.push(true);
            break;
          case 4:
            assetEditStatus.push("Load");
            assetEditStatus.push(true);
            break;
          case 5:
            assetEditStatus.push("EV");
            assetEditStatus.push(true);
            break;
          case 6:
            assetEditStatus.push("CB");
            assetEditStatus.push(true);
            break;
          case 7:
            assetEditStatus.push("CHP");
            assetEditStatus.push(true);
            break;
          case 8:
            assetEditStatus.push(`Power meter`);
            assetEditStatus.push(true);
            break;
          case 9:
            assetEditStatus.push("Hybrid");
            assetEditStatus.push(true);
            break;
          default:
            break;
        }
        sessionStorage.setItem("assetEditStatus", assetEditStatus);
        break;
      }
    }
  };

  const updateDerHistory = (index) => {
    let derHistory = JSON.parse(sessionStorage.getItem("derHistory"));
    if (index === 0) {
      derHistory.Utility = {};
    } else if (index === 1) {
      derHistory.Genset = {};
    } else if (index === 2) {
      derHistory.BESS = {};
    } else if (index === 5) {
      derHistory.EV = {};
    } else if (index === 7) {
      derHistory.CHP = {};
    } else if (index === 9) {
      derHistory.Hybrid = {};
    } else if (index === 10) {
      derHistory.GT = {};
    }

    sessionStorage.setItem("derHistory", JSON.stringify(derHistory));
  };

  const updateLoadHistory = (index) => {
    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    let loadHistory = [];
    if (derStatus[4] === true) {
      loadHistory = JSON.parse(sessionStorage.getItem("loadHistory"));
    }

    if (loadHistory.length) {
      delete loadHistory[index];
    }
    sessionStorage.setItem("loadHistory", JSON.stringify(loadHistory));

    if (loadHistory.length) {
      let status = false;
      for (let i = 0; i < loadHistory.length; i++) {
        if (loadHistory[i] === null) {
          status = status === false ? false : true;
        } else if (loadHistory[i] === undefined) {
          status = status === false ? false : true;
        } else {
          status = true;
        }
      }
      derStatus[4] = status;
    } else {
      derStatus[4] = false;
    }
    sessionStorage.setItem("derStatus", JSON.stringify(derStatus));
    detailsModifiedStataus();
  };

  const updateEvCbHistory = (index) => {
    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    let cbEvHistory = [];
    if (derStatus[6] === true) {
      cbEvHistory = JSON.parse(sessionStorage.getItem("cbEvHistory"));
    }

    if (cbEvHistory.length) {
      delete cbEvHistory[index];
    }

    sessionStorage.setItem("cbEvHistory", JSON.stringify(cbEvHistory));
    checkCBStatus();
  };

  const updateLoadCbHistory = (index) => {
    if(sessionStorage.getItem("derStatus")){
    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    let cbLoadHistory = [];
    if (derStatus[6] === true && sessionStorage.getItem("cbLoadHistory")) {
      cbLoadHistory = JSON.parse(sessionStorage.getItem("cbLoadHistory"));
    }

    if (cbLoadHistory.length) {
      delete cbLoadHistory[index];
    }
    sessionStorage.setItem("cbLoadHistory", JSON.stringify(cbLoadHistory));}
    checkCBStatus();
  };
 const updateGtCbHistory = (index) => {
    if(sessionStorage.getItem("derStatus")){
    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    let cbGtHistory = [];
    if (derStatus[10] === true && sessionStorage.getItem("cbGtHistory")) {
      cbGtHistory = JSON.parse(sessionStorage.getItem("cbGtHistory"));
    }

    if (cbGtHistory.length) {
      delete cbGtHistory[index];
    }
    sessionStorage.setItem("cbGtHistory", JSON.stringify(cbGtHistory));}
    checkCBStatus();
  };
  const updateAssetCbHistory = (index) => {
    if(sessionStorage.getItem("derStatus")){
    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    let cbAssetHistory = [];
    if (derStatus[6] === true) {
      cbAssetHistory = sessionStorage?.getItem("cbAssetHistory") &&JSON?.parse(sessionStorage?.getItem("cbAssetHistory"));
    }

    if (cbAssetHistory.length) {
      delete cbAssetHistory[index];
    }
  
    sessionStorage.setItem("cbAssetHistory", JSON.stringify(cbAssetHistory));
  }
    checkCBStatus();
  };

  const updateAssetPmHistory = (index) => {
    if(sessionStorage.getItem("derStatus")){

    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    let pmAssetHistory = [];
    if (derStatus[8] === true) {
      pmAssetHistory = JSON.parse(sessionStorage.getItem("pmAssetHistory"));
    }
  

    if (pmAssetHistory.length) {
      delete pmAssetHistory[index];
    }

    sessionStorage.setItem("pmAssetHistory", JSON.stringify(pmAssetHistory));
  }
    checkPmStatus();
  };

  const updateEvPmHistory = (index) => {
    if(sessionStorage.getItem("derStatus")){

    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    let pmEvHistory = [];
    if (derStatus[8] === true) {
      pmEvHistory = JSON.parse(sessionStorage.getItem("pmEvHistory"));
    }
  

    if (pmEvHistory.length) {
      delete pmEvHistory[index];
    }
    sessionStorage.setItem("pmEvHistory", JSON.stringify(pmEvHistory))}
    checkPmStatus();
  };

  const checkCBStatus = () => {
    if(sessionStorage.getItem("derStatus")){

    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));

    let cbLoadHistory = [];
    if (sessionStorage.getItem("cbLoadHistory") === "") {
      cbLoadHistory = [];
    } else {
      cbLoadHistory = JSON.parse(sessionStorage.getItem("cbLoadHistory"));
    }
    let status = false;
    if (cbLoadHistory.length) {
      for (let i = 0; i < cbLoadHistory.length; i++) {
        if (cbLoadHistory[i] === null) {
          status = status === false ? false : true;
        } else if (cbLoadHistory[i] === undefined) {
          status = status === false ? false : true;
        } else {
          status = true;
        }
      }
    } else {
      status = status === false ? false : true;
    }
  

    let cbAssetHistory = [];
    if (sessionStorage.getItem("cbAssetHistory") === "") {
      cbAssetHistory = [];
    } else {
      cbAssetHistory = JSON.parse(sessionStorage.getItem("cbAssetHistory"));
    }

    if (cbAssetHistory.length) {
      for (let i = 0; i < cbAssetHistory.length; i++) {
        if (cbAssetHistory[i] === null) {
          status = status === false ? false : true;
        } else if (cbAssetHistory[i] === undefined) {
          status = status === false ? false : true;
        } else {
          status = true;
        }
      }
    } else {
      status = status === false ? false : true;
    }

    let cbEvHistory = [];
    if (sessionStorage.getItem("cbEvHistory") === "") {
      cbEvHistory = [];
    } else {
      cbEvHistory = JSON.parse(sessionStorage.getItem("cbEvHistory"));
    }
    if (cbEvHistory.length) {
      for (let i = 0; i < cbEvHistory.length; i++) {
        if (cbEvHistory[i] === null) {
          status = status === false ? false : true;
        } else if (cbEvHistory[i] === undefined) {
          status = status === false ? false : true;
        } else {
          status = true;
        }
      }
    } else {
      status = status === false ? false : true;
    }

    derStatus[6] = status;
    sessionStorage.setItem("derStatus", JSON.stringify(derStatus));
  }
    detailsModifiedStataus();
  };

  const checkPmStatus = () => {
    if(sessionStorage.getItem("derStatus")){
    
    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));

    let pmAssetHistory = [];
    if (sessionStorage.getItem("pmAssetHistory") === "") {
      pmAssetHistory = [];
    } else {
      pmAssetHistory = JSON.parse(sessionStorage.getItem("pmAssetHistory"));
    }
    let status = false;
    if (pmAssetHistory.length) {
      for (let i = 0; i < pmAssetHistory.length; i++) {
        if (pmAssetHistory[i] === null) {
          status = status === false ? false : true;
        } else if (pmAssetHistory[i] === undefined) {
          status = status === false ? false : true;
        } else {
          status = true;
        }
      }
    } else {
      status = status === false ? false : true;
    }

    let pmEvHistory = [];
    if (sessionStorage.getItem("pmEvHistory") === "") {
      pmEvHistory = [];
    } else {
      pmEvHistory = JSON.parse(sessionStorage.getItem("pmEvHistory"));
    }

    if (pmEvHistory.length) {
      for (let i = 0; i < pmEvHistory.length; i++) {
        if (pmEvHistory[i] === null) {
          status = status === false ? false : true;
        } else if (pmEvHistory[i] === undefined) {
          status = status === false ? false : true;
        } else {
          status = true;
        }
      }
    } else {
      status = status === false ? false : true;
    }

    derStatus[8] = status;
    sessionStorage.setItem("derStatus", JSON.stringify(derStatus));
  }
    detailsModifiedStataus();
  };

  const updatePvHistoryFull = (mainIndex) => {
    if(sessionStorage.getItem("derStatus")){

    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    let pvHistory = JSON.parse(sessionStorage.getItem("pvHistory"));
    let status = false;
    if (mainIndex === 3) {
      pvHistory.pv1 = [];
      status = false;
    } else if (mainIndex === 4) {
      pvHistory.pv2 = [];
      status = false;
    } else if (mainIndex === 5) {
      pvHistory.pv3 = [];
      status = false;
    }

    derStatus[3] = status;
    sessionStorage.setItem("derStatus", JSON.stringify(derStatus));
    sessionStorage.setItem("pvHistory", JSON.stringify(pvHistory));
  }
    detailsModifiedStataus();
  };

  const updatePvHistory = (subIndex, mainIndex) => {
    if(sessionStorage.getItem("derStatus")){

    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    let pvHistory = JSON.parse(sessionStorage.getItem("pvHistory"));
    let status = false;
    if (mainIndex === 3) {
      if (pvHistory.pv1.length) {
        delete pvHistory.pv1[subIndex];
        for (let i = 0; i < pvHistory.pv1.length; i++) {
          if (pvHistory.pv1[i] === null) {
            status = status === false ? false : true;
          } else if (pvHistory.pv1[i] === undefined) {
            status = status === false ? false : true;
          } else {
            status = true;
          }
        }
      } else {
        status = false;
      }
    } else if (mainIndex === 4) {
      if (pvHistory.pv2.length) {
        delete pvHistory.pv2[subIndex];
        for (let i = 0; i < pvHistory.pv2.length; i++) {
          if (pvHistory.pv2[i] === null) {
            status = status === false ? false : true;
          } else if (pvHistory.pv2[i] === undefined) {
            status = status === false ? false : true;
          } else {
            status = true;
          }
        }
      } else {
        status = false;
      }
    } else if (mainIndex === 5) {
      if (pvHistory.pv3.length) {
        delete pvHistory.pv3[subIndex];
        for (let i = 0; i < pvHistory.pv2.length; i++) {
          if (pvHistory.pv2[i] === null) {
            status = status === false ? false : true;
          } else if (pvHistory.pv3[i] === undefined) {
            status = status === false ? false : true;
          } else {
            status = true;
          }
        }
      } else {
        status = false;
      }
    }

    derStatus[3] = status;
    sessionStorage.setItem("derStatus", JSON.stringify(derStatus));
    sessionStorage.setItem("pvHistory", JSON.stringify(pvHistory));
  }
    detailsModifiedStataus();
  };

  const updateDerStatus = (index) => {
    if(sessionStorage.getItem("derStatus")){

    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    derStatus[index] = false;
    sessionStorage.setItem("derStatus", JSON.stringify(derStatus));
    }
    detailsModifiedStataus();
  };

  const updatePvHistoryGroupPower = (selectedPv) => {
    let pvGroupPower = JSON.parse(sessionStorage.getItem("pvGroupPower"));
    if (selectedPv === 3) {
      pvGroupPower.pv1 = "";
    } else if (selectedPv === 4) {
      pvGroupPower.pv2 = "";
    } else if (selectedPv === 5) {
      pvGroupPower.pv3 = "";
    }
    sessionStorage.setItem("pvGroupPower", JSON.stringify(pvGroupPower));
  };


  return {
    closePvDetailsBlock,
    isCopyAllButtonDisabled,
    copyAllPvs,
    assetEditStatusUpdateDER,
    assetEditStatusUpdateLoad,
    assetEditStatusUpdateAssetCB,
    assetEditStatusUpdateLoadCb,
    assetEditStatusUpdateGtCb,
    assetEditStatusUpdateEvCb,
    assetEditStatusUpdatePv,
    assetEditStatusUpdateAssetPM,
    assetEditStatusUpdateEvPM,
    checkUpdatedStatus,
    detailsModifiedStataus,
    updateDerHistory,
    updateLoadHistory,
    updateEvCbHistory,
    updateLoadCbHistory,
    updateGtCbHistory,
    updateAssetCbHistory,
    updateAssetPmHistory,
    updateEvPmHistory,
    checkCBStatus,
    checkPmStatus,
    updatePvHistoryFull,
    updatePvHistory,
    updateDerStatus,
    updatePvHistoryGroupPower,
  };
};

export default useAssetEditStatus;